import { io } from 'socket.io-client'

const url = process.env.CITYPAY_BOT_URL
const socketCityPayBot = io(url, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
  timeout: 90000,
})


export default socketCityPayBot